// Demo mode singleton — when set, the dashboard renders public read-only data
// for the configured client_id and bypasses authentication. Mutating actions
// (execute-move, find-new-questions, generate-ai-insight, etc.) become no-ops.

let demoClientId: string | null = null;

export const SANDTON_DEMO_CLIENT_ID = "383b3842-d83e-4ae2-ad28-d05c47ed3142";

export const setDemoClientId = (id: string | null) => {
  demoClientId = id;
};

export const getDemoClientId = () => demoClientId;

export const isDemoMode = () => demoClientId !== null;

import { toast } from "@/hooks/use-toast";

export const blockIfDemo = (label = "This action"): boolean => {
  if (isDemoMode()) {
    toast({
      title: "Demo mode",
      description: `${label} is disabled in the live demo.`,
    });
    return true;
  }
  return false;
};
